import { NotificationService } from '~/passporter-services/notification/service'
import { Page } from '~/models/PaginatedItems'
import { Notification } from '~/models/Notification'
import Calendar from '../../passporter-services/shared/calendar'
import { TranslationService } from '../../services/Translation'
import EventsService from '~/services/events'

export class NotificationActions {
	static async getByUser(userId: string, page?: number): Promise<Page<Notification>> {
		try {
			return await NotificationService.getUserNotifications(userId, page)
		} catch {
			return { items: [] }
		}
	}

	static formatByDay(
		notifications: Notification[],
		locale: string
	): Record<string, Notification[]> {
		const calendar = new Calendar(locale)
		const today = this.getToday(calendar)
		const yesterday = this.getYesterday(calendar)
		const byDay: Record<string, Notification[]> = {}
		const t = TranslationService.getInstance()

		notifications.forEach((notification) => {
			let formattedDate = calendar.formatDayMonthToLocale(notification.created)
			if (formattedDate === today) formattedDate = t.translate('common.time.today')
			if (formattedDate === yesterday) formattedDate = t.translate('common.time.yesterday')
			if (!byDay[formattedDate]) byDay[formattedDate] = []
			byDay[formattedDate] = [...byDay[formattedDate]!, notification]
		})
		return byDay
	}

	static async countUnread(userId: string): Promise<number> {
		try {
			return await NotificationService.countUnread(userId)
		} catch {
			return 0
		}
	}

	static async markAsRead(notificationId: string): Promise<void> {
		try {
			await NotificationService.markAsRead(notificationId)
		} catch {
			return
		}
	}

	static async markAllAsRead(): Promise<void> {
		try {
			await NotificationService.markAllAsRead()
		} catch {
			const t = TranslationService.getInstance()
			EventsService.emitError(t.translate('web.home.notifications.toast.mark_all_as_read_error'))
		}
	}

	private static getToday(calendar: Calendar) {
		return calendar.formatDayMonthToLocale(new Date())
	}

	private static getYesterday(calendar: Calendar) {
		const today = new Date()
		const yesterday = new Date(today.setDate(today.getDate() - 1))
		return calendar.formatDayMonthToLocale(yesterday)
	}
}
